const binding = { modules: {}, dataActions: {} };

    (binding.modules['eve-form'] = {
        c: () => require('partner/modules/eve-form/eve-form.tsx'),
        $type: 'containerModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'eve-form',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/eve-form'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|eve-form|eve-form'] = {
                c: () => require('partner/modules/eve-form/eve-form.view.tsx'),
                cn: '__local__-__local__-eve-form'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };